import { createFileRoute } from '@tanstack/react-router';
import { AdminLayout } from '../app/layouts/admin-layout';

/** Admin console: platform role required; branded `.theme-oex`. */
export const Route = createFileRoute('/admin')({ component: AdminLayout });
